<template>
    <li class="list-group-item" :class="detalle ? 'lightgray2-content' : ''">
        <div class="row">
            <div class="col-12 d-flex justify-content-between" @click="detalle = !detalle">
                <span>
                    <b>{{ pedido.evento.name }}</b>
                    <span v-if="pedido.sesion"> / <b>{{ pedido.sesion.fecha }}</b></span>
                    / {{ $t('perfil.n_pedido') }}: {{ pedido.id }}
                    / <b>{{ $t('perfil.entradas') }}: {{ pedido.entradas.length }}</b></span>
                <span>
                    <i :class="detalle ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                </span>
            </div>
            <transition name="fade" mode="out-in">
                <div class="col-12" v-if="detalle">
                    <div class="row pt-2">
                        <div class="col-12 mt-2 mb-3 d-flex justify-content-center">
                            <a v-if="!anuladas" class="button" :href="pedido.url_pdf" target="_blank">{{ $t('perfil.descargar_todas') }}</a>
                        </div>
                        <div class="col-12">
                            <div class="row pr-md-4 pl-md-4">
                                <template v-for="(entrada, index) in pedido.entradas">
                                    <div class="col-12 d-flex justify-content-between" :key="entrada.id">
                                        <ul class="list-group pb-4" style="width: 100%">
                                            <li class="list-group-item">{{ $t('perfil.entrada') }} N°: <b>{{++index}}</b></li>
                                            <li class="list-group-item">{{ $t('perfil.qr_code') }}: <b>{{ entrada.qr_code }}</b></li>
                                            <li class="list-group-item">{{ $t('perfil.ANULADA') }}: <b>{{entrada.deleted_at ? 'SI' : 'NO'}}</b></li>
                                            <li class="list-group-item" v-if="!entrada.deleted_at && (pedido.date_caducidad || entrada.date_caducidad && entrada.deleted_at)">
                                                <ul  class="list-group" style="list-style:none;">
                                                    <li>{{ $t('perfil.caducara') }}: {{!entrada.download_date  ? 'SI' : 'NO'}}</li>
                                                    <li v-if="!entrada.download_date">{{ $t('perfil.fecha') }}: {{pedido.date_caducidad ? pedido.fecha_caducidad : entrada.fecha_caducidad }}</li>
                                                </ul>
                                            </li>
                                            <li class="list-group-item">
                                                {{ $t('formularios.dni') }}: <b>{{ entrada.user_dni }}</b>
                                                <CambiarDatos v-if="entrada.puede_cambiar_datos && !entrada.deleted_at" :entrada="entrada" :esMovil="esMovil" :left="'15em'" :top="'0.5em'" @close="closeModal" @show="showModal"/>
                                            </li>
                                            <li class="list-group-item">
                                                {{ $t('formularios.nombre') }}: <b>{{ entrada.user_nombre }} {{ entrada.user_apellidos }}</b>
                                                <CambiarDatos v-if="entrada.puede_cambiar_datos && !entrada.deleted_at" :entrada="entrada" :esMovil="esMovil" :left="'33.1em'" :top="'0.55em'" @close="closeModal" @show="showModal"/>
                                            </li>
                                            <li class="list-group-item">Enviado: <b>{{entrada.enviado ? 'SI' : 'NO'}}</b></li>
                                            <template v-if="entrada.asiento">
                                                <li class="list-group-item">
                                                    Zona: <b>{{ entrada.asiento.zona }}</b>
                                                </li>
                                                <li class="list-group-item">
                                                    Fila: <b>{{ entrada.asiento.fila }}</b>
                                                </li>
                                                <li class="list-group-item">
                                                    Asiento: <b>{{ entrada.asiento.asiento }}</b>
                                                </li>
                                            </template>
                                            <li class="list-group-item d-flex justify-content-between" v-if="entrada.deleted_at == null">
                                                <a class="button" :href="entrada.url_pdf" target="_blank">{{ $t('perfil.descargar') }}</a>
                                            </li>
                                        </ul>                                   
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>                            
            </transition>
        </div>
    </li>
</template>

<script>
    import { config } from '@/config.js';
    import CambiarDatos from './CambiarDatos';

    export default {
        props: ['pedido', 'esMovil'],
        data() {
            return {
                detalle: false,
                config: config
            }
        },
        computed: {
            anuladas() {
                var countAnuladas = this.pedido.entradas.filter(entrada => entrada.deleted_at != null).length;
                var countEntradas = this.pedido.entradas.length;

                if (countAnuladas == countEntradas) {
                    return true;
                } else {
                    return false;
                }

            },
        },
        methods: {
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        components: {
            CambiarDatos
        }
    }
</script>
